import React from 'react';

import { Reveal } from '../../../../components/Reveal';
import { Section, SectionInner } from '../../styles';
import {
  Bullet,
  Eyebrow,
  Grid,
  ItemDescription,
  ItemTitle,
  List,
  ListItem,
  Panel,
  PanelHeading,
  ResultCallout,
  ResultLabel,
  ResultText,
} from './styles';

const before = [
  {
    title: 'Fichas de papel e pranchetas acumuladas',
    description:
      'Fichas físicas que se perdem, geram rasuras e passam uma imagem antiquada para o aluno.',
  },
  {
    title: 'Demora na prescrição de novos treinos',
    description:
      'Instrutores gastam horas montando fichas do zero, acumulando fila e atrasando o atendimento na sala de musculação.',
  },
  {
    title: 'Alunos executando exercícios de forma errada',
    description:
      'Instrutores sobrecarregados não conseguem acompanhar todos, gerando insegurança e falta de evolução do aluno.',
  },
  {
    title: 'Falta de visão geral e acompanhamento da operação',
    description:
      'Sem dados de quem realmente está treinando, quais fichas estão vencidas ou como está a frequência geral do espaço.',
  },
];

const after = [
  {
    title: 'Fichas digitais na palma da mão',
    description:
      'Treinos acessíveis instantaneamente pelo aplicativo no celular do aluno, sem poluição de papel.',
  },
  {
    title: 'Prescrição ágil em menos de 2 minutos',
    description:
      'Biblioteca nativa com +170 exercícios para criar e atualizar treinos em poucos cliques.',
  },
  {
    title: 'Demonstração visual de cada execução',
    description:
      'Vídeos e instruções nativas no app para o aluno executar as séries com postura correta e autonomia.',
  },
  {
    title: 'Acompanhamento em tempo real e visão 360°',
    description:
      'Painel completo com histórico de treinos realizados, frequência dos alunos e métricas da academia.',
  },
];

const ProblemSolution: React.FC = () => {
  return (
    <Section id="solucao">
      <SectionInner>
        <Grid>
          <Reveal direction="left">
            <Panel tone="before">
              <Eyebrow tone="before">Modelo tradicional</Eyebrow>
              <PanelHeading>
                O que atrasa o crescimento da sua academia hoje:
              </PanelHeading>
              <List>
                {before.map(item => (
                  <ListItem key={item.title}>
                    <Bullet tone="before">×</Bullet>
                    <div>
                      <ItemTitle>{item.title}</ItemTitle>
                      <ItemDescription tone="before">
                        {item.description}
                      </ItemDescription>
                    </div>
                  </ListItem>
                ))}
              </List>
            </Panel>
          </Reveal>

          <Reveal direction="right">
            <Panel tone="after">
              <Eyebrow tone="after">Com a TrenzoX</Eyebrow>
              <PanelHeading>
                A transformação prática no dia a dia do seu espaço:
              </PanelHeading>
              <List>
                {after.map(item => (
                  <ListItem key={item.title}>
                    <Bullet tone="after">✓</Bullet>
                    <div>
                      <ItemTitle>{item.title}</ItemTitle>
                      <ItemDescription tone="after">
                        {item.description}
                      </ItemDescription>
                    </div>
                  </ListItem>
                ))}
              </List>
            </Panel>
          </Reveal>
        </Grid>

        <ResultCallout>
          <ResultLabel>O resultado na prática:</ResultLabel>
          <ResultText>
            Menos tempo gasto em tarefas burocráticas, maior retenção de alunos
            pagantes e uma percepção de valor muito superior para o seu negócio.
          </ResultText>
        </ResultCallout>
      </SectionInner>
    </Section>
  );
};

export { ProblemSolution };
